'use client';

import { useAuthMutations  } from '@/modules/authentication/contracts';
import type { ResetPasswordDto } from '@/modules/authentication/contracts';

import { Result } from '@packages/domain-driven';

export const useResetPassword = () => {
	const { resetPasswordMutation } = useAuthMutations();

	const submit = async (dto: ResetPasswordDto) => {
		try {
			if (!dto.oob) return Result.fail('Invalid or missing oob code');

			await resetPasswordMutation.mutateAsync(dto);

			return Result.ok();
		}
		catch {
			return Result.fail('Invalid or missing oob code');
		}
	};

	return {
		submit,
		...resetPasswordMutation,
	};
};
